import React, { Component } from 'react';
import { CURRENCY, FORMAT_NUMBER, json, Modules, Granel, Envasados, Anticipo, isEntregaCilindro, isTipoConvenio, isCilindrosVaciosDevueltos, isTipodeGasto } from '../../../libs/utils/Const';
import { ToolTip } from '../..';
import { formatNumber, isMarketingDocument, isAnticipo } from '../../../libs/utils/GlobalFunc';

class OriginalTable extends Component {




    render() {
        const { type } = this.props;
        return (
            <>
                {type === 'HEAD' ? (
                    this.OriginalHeader()
                ) : (
                    this.OriginalBody()
                )}
            </>
        );
    }

    OriginalHeader = () => {
        const { newOrderModel, action, view, ShowBatchDefinitionModal } = this.props;
        const { isSelectTo } = newOrderModel;
        let isPurchaseQuotation = newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft';
        let noPurchaseQuotationExists = !isPurchaseQuotation || !newOrderModel.newView;
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        let itemsBatch = newOrderModelItems.filter((item) => item.ManBtchNum === 'Y');
        const locationView = ['GoodsReceipt', 'transfersEntry', 'transfersOutput'];
        const newView = newOrderModel?.newView || view || '';
        const isLocationView = locationView?.includes(newView ?? '');

        return (
            <tr style={{ textAlign: "center" }} >
                <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    #
                </td>
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Artículo
                </td>
                <td className="sticky-header" style={{ maxWidth: 800, backgroundColor: '#d2ab24' }}>
                    Descripción
                </td>
                {/* {
                                    ((view ==='invoice' || view ==='creditNote' || view ==='debitNote' || view ==='orderSales' || view ==='deliveries' || view ==='invoiceAuthorization' || view === 'invoiceBorrador' || view ==='invoiceReserve') && (
                                    <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                        Unidad de Medida de I.
                                    </td>))
                                    } */}
                <td className="sticky-header" style={{/*maxWidth: 100,*/minWidth: 180, backgroundColor: '#d2ab24' }}>
                    Almacén
                </td>
                {((view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                    <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}>
                        Disponible
                    </td>))
                }
                {(view === 'PurchaseRequest' && noPurchaseQuotationExists) &&
                    <>
                        <td className="sticky-header" style={{ minWidth: 170, backgroundColor: '#d2ab24' }}> Proveedor </td>
                        <td className="sticky-header" style={{ minWidth: 170, backgroundColor: '#d2ab24' }}> Cantidad en Almacén </td>
                    </>
                }
                {(isPurchaseQuotation || Number(newOrderModel?.ObjType) === 540000006) &&
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                        Cantidad necesaria
                    </td>
                }
                {newOrderModel.isTransferDocument &&
                    <>
                        <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                            UND Med.
                        </td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                            Cant. Galones
                        </td>
                        <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                            Precio Galones
                        </td>
                        <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                            Total Galones
                        </td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                            Densidad
                        </td>
                    </>
                }
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    {isSelectTo ? 'Cantidad Abierta' : view === 'invoiceBorrador' ? 'Cantidad original' : 'Cantidad'}
                </td>

                {view === 'PurchaseOrder' && (
                    <>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Cantidad en Almacén
                        </td>

                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Cantidad Entregada
                        </td>

                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Cantidad Pendiente
                        </td>
                    </>
                )}

                {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Cerrada
                </td>}
                {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Original
                </td>}
                {view === 'invoiceBorrador' && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Abierta
                </td>}
                {view === 'invoiceBorrador' && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Entregada
                </td>}
                <td className="sticky-header" style={{ width: view === 'PurchaseRequest' ? 220 : 170, backgroundColor: '#d2ab24' }}>
                    Precio
                </td>

                <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                    Costo artículo
                </td>
                {/* Casco */}
                {(action === 1 && isMarketingDocument(view)) &&
                    <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                        Cilindro
                    </td>
                }

                <td className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}>
                    %Desc
                </td>
                <th className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Descuento
                </th>
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Indicador I.
                </td>
                {newOrderModel?.isPurchaseDocument &&
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                        Código UM
                    </td>
                }
                {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && (
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                        Código UMI
                    </td>)
                }
                {(view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'purchaseReturn') && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Impuesto
                </td>}
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Total
                </td>
                {/* {view !== 'PurchaseRequest' && Modules.CostCenter && <>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                        Cod. Norma Reparto C.C
                    </td> */}
                {/* <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Cod. Norma Reparto C.C 2
                                            </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Cod. Norma Reparto C.C 3
                                            </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Cod. Norma Reparto C.C 4
                                            </td>
                                            <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                Cod. Norma Reparto C.C 5
                                            </td> */}
                {/* </>} */}
                {(newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument) && Modules.CostCenter && <>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        CANAL
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        SEDES
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        SUCURSAL
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        NEGOCIO
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        CECO
                    </td>
                </>}
                {(view === 'purchaseInvoice') && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Proyecto
                </td>}
                {/*Orden, Entrada y Factura de proveedor*/}
                {/* Pronto Pago */}
                {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseInvoice') &&
                    <>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            <div className="d-flex">
                                Desc pronto pago
                                <ToolTip tips={[{ message: `${FORMAT_NUMBER.new(newOrderModel.U_FMB_DescPP || 0)} %` }]} width="200" />
                            </div>
                        </td>
                    </>
                }
                {/*Orden de compra - Entrada de mercancia de proveedor*/}
                {/*PrecioXKilo*/}
                {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt') &&
                    <>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Kilos por comprar
                        </td>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Pesos por pieza
                        </td>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Precio por kilo
                        </td>
                    </>
                }

                {/* {view !== 'PurchaseRequest' &&
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 1
                                    </td>}
                                    {view !== 'PurchaseRequest' &&
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 2
                                    </td>}
                                    {view !== 'PurchaseRequest' &&
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 3
                                    </td>}
                                    {view !== 'PurchaseRequest' &&
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Centro 4
                                    </td>} */}


                {/* CAMPOS DE USUARIO LINE */}
                {json.allItemsUserFields.map((field, index) => {
                    if (field.enabled && field.name && ((!newOrderModel?.isPurchaseDocument && field.fieldId !== isTipodeGasto) ||
                        (newOrderModel?.isPurchaseDocument && field.fieldId !== isEntregaCilindro && field.fieldId !== isTipoConvenio && field.fieldId !== isCilindrosVaciosDevueltos))
                    ) {
                        return (
                            <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                {field.name}
                            </td>
                        );
                    }
                })}
                {/*
                                        <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                            Cuenta de Mayor
                                        </td>
                                        <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                            Cuenta Precio Coste
                                        </td>*/}
                {newOrderModel?.isPurchaseDocument &&
                    <>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>Ctd.(UM inventario)</td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>Detalles de artículo</td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>Operación</td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>Cod. Afectación</td>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>Sujeto a Impuesto</td>
                        <td className="sticky-header" style={{ minWidth: 150, backgroundColor: '#d2ab24' }}>Proyecto/Placa</td>
                    </>
                }
                {isLocationView && (
                    <>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>Asignación de ubicación</td>
                    </>
                )}
                {(view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && itemsBatch.length > 0 && (
                    <td
                        className="sticky-header sticky-columns"
                        style={{ backgroundColor: '#d2ab24' }}
                    >
                        <i className="fa fa-th" aria-hidden="true" data-toggle="modal" data-target="#batchDefinitionModal" onClick={ShowBatchDefinitionModal}></i>
                    </td>)
                }
            </tr>
        )
    }

    OriginalBody = () => {
        const {
            newOrderModel
            , action
            , view
            , ShowBatchDefinitionModal
            , editMode
            , _user
            , changeQuantityItem
            , openAlmacen
            , changeAlmacen
            , openPartner
            , ChangeLineVendor
            , specialPrice
            , changePriceInvntItem
            , changeSearchItem
            , openItems
            , returnValueItem
            , changePriceItem
            , validatePriceNull
            , validateCasco
            , changeDiscountItem
            , validateDiscountNull
            , openTaxes
            , openCentroCoste
            , openProjects
            , changeKilosXComprar
            , validateKilosXComprar
            , changePesosXPieza
            , validatePesosXPieza
            , changePrecioXKilo
            , validatePrecioXKilo
            , changeUserFieldsItemsDocument
            , deleteItem
            , operationList
            , igvOperationList
            , changeOperation
            , changeIgvOperation
            , changeLineField
            , changeTaxStatus
            , showDocumentStock
            , showLocationAssignment
            , docCurrencies = []
            , changeCurrItem
            , changeUserUM
            , changeGalonesCant
            , changeQuantityBlur
            , onBlurWhs
            , clickPriceCalculate
            , isCopyToOPOR = false
        } = this.props;
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        let newView = newOrderModel?.newView || view;
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        let isPurchaseQuotation = newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft';
        let noPurchaseQuotationExists = !isPurchaseQuotation || !newOrderModel.newView;
        const locationView = ['GoodsReceipt', 'transfersEntry', 'transfersOutput'];
        const isLocationView = locationView?.includes(newView ?? '');

        return <>
            {newOrderModelItems.map((item, index) => {
                const whsOnHand = Array.isArray(item?.wareHouseStock) ? (item?.wareHouseStock?.find(({ WhsCode }) => WhsCode === item.WhsCode)?.OnHand || 0) : 0;
                const deliveredQty = (() => {
                    const d = Number(item?.DelivrdQty);
                    if (Number.isFinite(d) && d !== 0) return d;
                    if (view === 'PurchaseOrder') return (Number(item?.Quantity) || 0) - (Number(item?.OpenQty) || 0);
                    return d || 0;
                })();
                const oneIgvOption = item.U_STR_FECodAfect && !item?.availableIgvOperationList?.length ? igvOperationList.filter(({ Code }) => Code === item.U_STR_FECodAfect) : [];
                const showPriceCalculate = isAnticipo(item.ItemCode) && ((view === 'invoiceAdvance' && !newOrderModel?.newView) || newOrderModel?.newView === 'invoiceAdvance');
                return (
                    <tr style={{
                        maxHeight: 10,
                        paddingTop: 8,
                        paddingBottom: 8,
                        borderBottom: view === 'PurchaseOrder' || newOrderModel?.isPurchaseDocument ? '1px solid #6c757db5' : 'none',
                        color: !item.stock && (view === 'deliveries' || view === 'invoice' || view === 'debitNote' || newView === 'deliveries' || newView === 'invoice' || newView === 'debitNote') ? 'red' : 'black',
                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : (newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? '#FFD19B' : 'transparent' : 'transparent'
                    }}
                        title={(newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? 'Línea no existente en documento base' : '' : ''}
                        data-toggle={(newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? 'tooltip' : '' : ''}

                    >
                        <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                            {index + 1}
                        </td>
                        {/*Artículos*/}
                        <td className="overflow-visible"
                            style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                            {item.ItemCode}
                        </td>

                        {/*Descripción*/}
                        <td
                            className="overflow-visible"
                            style={{ textAlign: 'center', maxWidth: 800, minWidth: 250 }}>
                            {item.ItemName}
                        </td>


                        {/*Unidad de medida de inventario*/}
                        {/* {((view ==='invoice' || view ==='creditNote' || view ==='debitNote' || view ==='orderSales' || view ==='deliveries'  || view ==='invoiceAuthorization' || view === 'invoiceBorrador' || view ==='invoiceReserve') && (       
                                          <td>
                                                <select className="form-control"
                                                 disabled={(action == 2 && !editMode) ? true : false}
                                                 onChange={event =>this.changeUserFieldsDocumentItemUnitMed(event,index)}
                                                 value={item.UserBaseUn} >
                                                    <option value={'N'}> {'No'}</option>
                                                    <option value={'Y'}> {'Si'}</option>
                                               </select>
                                        </td>))} */}
                        <td style={{ textAlign: 'center' }}>
                            <div className='input-group'>
                                {/*Almacen*/}
                                <input
                                    type=" text"
                                    placeholder="Almacén"
                                    className=" form-control validarCant cantBlur btn-outline text-center"
                                    disabled={action === 2 && !editMode ? true : false}
                                    style={{
                                        backgroundColor: item.whsSelected ? 'rgb(248,242,209)' : 'transparent',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        //maxWidth: 100,
                                        minWidth: 100,
                                        widht: 150,
                                    }}
                                    onKeyPress={(eve) => {
                                        if (eve.key === 'Enter') {
                                            openAlmacen(index, 1, item.ItemCode);
                                        }
                                    }}
                                    value={item.WhsCode}
                                    onChange={event => changeAlmacen(index, event)}
                                    onBlur={event => onBlurWhs(index, event)}
                                />
                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus) || (action == 2 && editMode && view === 'draft')) && (
                                    <div className="input-group-append" >
                                        <button
                                            type="button"
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: '#EABF28',
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                                border: "1px solid #ced4da"
                                            }}
                                            className="btn btn-outline-secondary"
                                            onClick={() => openAlmacen(index, 1, item.ItemCode)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>
                        {/*U_Disponible*/}
                        {
                            ((view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                                <td>
                                    <input
                                        type=" text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        disabled={true}
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            // maxWidth: 100,
                                            minWidth: 80,
                                            textAlign: "center",
                                        }}
                                        value={Number.parseFloat(item.OnHand).toFixed(4) || 0}
                                    />
                                </td>))
                        }
                        {(view === 'PurchaseRequest' && noPurchaseQuotationExists) &&
                            <>
                                <td> {/*Proveedor*/}
                                    <div className='input-group'>
                                        <input
                                            className=" form-control text-center"
                                            disabled={action == 2 && !editMode}
                                            value={item.LineVendor}
                                            placeholder="Proveedor"
                                            onKeyDown={(eve) => { if (eve.key === 'Enter') { openPartner(index); } }}
                                            onChange={event => ChangeLineVendor(index, event)} />
                                        {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                            <div className="input-group-append" >
                                                <button type="button" className="btn btn-outline-warning" onClick={() => openPartner(index)}>
                                                    <i className="fa fa-list" />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td> {/* Cantidad en Almacén*/}
                                    <div className='input-group'>
                                        <input
                                            type="text"
                                            className="form-control text-center"
                                            readOnly
                                            value={formatNumber.new(whsOnHand || 0)} />
                                    </div>
                                </td>
                            </>
                        }
                        {/* Cantidad necesaria */}
                        {(isPurchaseQuotation || Number(newOrderModel?.ObjType) === 540000006) &&
                            <td style={{ textAlign: 'center' }}>
                                <label>{item.PQTReqQty ? formatNumber.new(item.PQTReqQty || 0) : ''} </label>
                            </td>
                        }
                        {newOrderModel.isTransferDocument &&
                            <>
                                {/* UND Med. */}
                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <select className="form-control"
                                                disabled={Number(action) !== 1}
                                                onChange={event =>
                                                    (Number(action) === 1) &&
                                                    changeUserUM(index, event)
                                                }
                                                value={item.U_RS_UMED || ''} >
                                                <option value={''}> {'Seleccionar'}</option>
                                                <option value={'KGM'}> {'Kilogramos'}</option>
                                                <option value={'GLN'}> {'Galones'}</option>
                                            </select>
                                        </td>
                                    </>
                                }
                                {/* Cant. Galones */}
                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`CANTG-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={(item.U_RS_UMED !== 'GLN' || (Number(action) !== 1))}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_CANTG || ''}
                                                onChange={event =>
                                                    item.U_RS_UMED === 'GLN' &&
                                                    Number(action) === 1 &&
                                                    changeGalonesCant(index, event)
                                                }
                                                onBlur={event =>
                                                    item.U_RS_UMED === 'GLN' &&
                                                    Number(action) === 1 &&
                                                    changeQuantityBlur(index, event, 'U_RS_CANTG')
                                                }
                                            />
                                        </td>
                                    </>
                                }
                                {/* Precio Galones */}
                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`PRECIOGL-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={true} readOnly={true}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_PRECIOGL || ''}
                                            />
                                        </td>
                                    </>
                                }
                                {/* Total Galones */}
                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`TOTALGL-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={true} readOnly={true}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_TOTALGL || ''}
                                            />
                                        </td>
                                    </>
                                }
                                {/* Densidad */}
                                {!(Granel ?? []).includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`DENS-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={true} readOnly={true}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_DENS || ''}
                                            />
                                        </td>
                                    </>
                                }
                            </>
                        }
                        <td>
                            <input
                                type="text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={item.Gallons ? true : (action == 2 && !editMode) ? true : (action == 2 && editMode && view == 'draft') ? false : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    width: 100,
                                    textAlign: "center",
                                }}
                                step="any"
                                id={'itemCantidad' + index}
                                value={item.Quantity}
                                onChange={event => changeQuantityItem(event, index)}
                                onBlur={() => specialPrice(index)}
                            />
                        </td>

                        {view === 'PurchaseOrder' && (
                            <>
                                {/* Cantidad en Almacén */}
                                <td className="text-center">
                                    <input
                                        type="text"
                                        className="form-control text-center"
                                        readOnly
                                        value={formatNumber.new(whsOnHand || 0)}
                                    />
                                </td>

                                {/* Cantidad Entregada */}
                                <td className="text-center">
                                    <input
                                        type="text"
                                        className="form-control text-center"
                                        readOnly
                                        value={formatNumber.new(deliveredQty || 0)}
                                    />
                                </td>

                                {/* Cantidad Pendiente */}
                                <td className="text-center">
                                    <input
                                        type="text"
                                        className="form-control text-center"
                                        readOnly
                                        value={formatNumber.new(item.OpenQty || 0)}
                                    />
                                </td>
                            </>
                        )}

                        {isSelectTo && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                disabled={true}
                                id={'itemCantidad' + index}
                                value={item.BaseEntry ? item.OriginalQuantityClose : ''}
                            />
                        </td>}

                        {isSelectTo && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={true}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                id={'itemCantidad' + index}
                                value={item.BaseEntry ? Number.parseFloat(item.OriginalQuantity).toFixed(4) : ''}
                            />
                        </td>}
                        {/* Cantidad abierta */}
                        {view === 'invoiceBorrador' && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={true}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                id={'itemCantidad' + index}
                                value={item.U_FMB_OpenQty || ''}
                            />
                        </td>}
                        {/* Cantidad entregada */}
                        {view === 'invoiceBorrador' && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={true}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                id={'itemCantidad' + index}
                                value={item.U_FMB_DelivrdQty || ''}
                            />
                        </td>}
                        {/*PRECIO*/}
                        {view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && view !== 'PurchaseRequest' && view !== 'invoiceAdvance' && !((view === 'invoiceBorrador' && newOrderModel?.isPurchaseDocument)) && !(view === 'invoiceAuthorization' && newOrderModel?.isPurchaseDocument) && !newOrderModel?.isPurchaseDocument && <td style={{ width: 130 }}>
                            {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                view === 'creditNote' ?
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="number"
                                                min={0}
                                                className="form-control validarCant cantBlur btn-outline-secondary"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    borderColor: '#ced4da',
                                                    color: '#000',
                                                    textAlign: 'right',
                                                    minWidth: '16vh',
                                                }}
                                                id={'itemCantidad' + index}
                                                disabled={!(item?.InvntItem && item.InvntItem === 'N')}
                                                value={item.Price ?? '0.00'}
                                                onChange={event => changePriceInvntItem(event.nativeEvent.target.value, index, false)}
                                                onBlur={event => changePriceInvntItem(event.nativeEvent.target.value, index, true)}
                                            />
                                        </div>
                                    </>
                                    :
                                    <input
                                        type="text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            width: 130,
                                            textAlign: 'right',
                                        }}
                                        id={'itemCantidad' + index}
                                        disabled={view !== 'purchaseCreditNotes'}
                                        value={CURRENCY + " " + formatNumber.new(item.Price)}
                                        onChange={event => changePriceItem(event, index)}
                                        onBlur={event => validatePriceNull(index)}
                                    />
                                :
                                <label
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        width: 130,
                                        textAlign: 'right',
                                    }}>
                                    {CURRENCY + " " + formatNumber.new(item.Price)}
                                </label>
                            }
                        </td>}
                        {/*PRECIO ENTRADA DE MERCANCIA */}
                        {view === 'GoodsReceipt' && <td style={{ width: 130 }}>
                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                <div className="input-group" style={{
                                    width: 170, flexWrap: 'nowrap',
                                    alignItems: 'center',
                                }}>
                                    <span className="input-group-text left"> {item.Currency ?? newOrderModel.DocCur ?? CURRENCY} </span>
                                    <input
                                        type="text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            width: 130,
                                            textAlign: 'right',
                                        }}
                                        id={'itemCantidad' + index}
                                        disabled={action == 1 ? false : true}
                                        value={item.Price}
                                        onChange={event => changePriceItem(event, index)}
                                        onBlur={event => validatePriceNull(index)}
                                    />
                                </div>
                                :
                                <label
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        // paddingBottom: 2,
                                        width: 130,
                                        textAlign: 'right',
                                    }}>
                                    {`${item.Currency ?? newOrderModel.DocCur ?? CURRENCY} ${formatNumber.new(item.Price)}`}
                                </label>
                            }
                        </td>}

                        {/*Precio*/}
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseDownPayments' || view === 'invoiceAdvance' || view === 'PurchaseRequest' || (view === 'invoiceBorrador' && newOrderModel?.isPurchaseDocument) || newOrderModel?.isPurchaseDocument || (view === 'invoiceAuthorization' && newOrderModel?.isPurchaseDocument)) && <td style={{ width: 130 }}>
                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                <div className="input-group" style={{
                                    width: view === 'PurchaseRequest' ? 220 : 170, flexWrap: 'nowrap',
                                    alignItems: 'center',
                                }}>

                                    {/* <label>
                                        {item.Currency ?? newOrderModel.DocCur ?? CURRENCY}
                                    </label> */}
                                    {view === 'PurchaseRequest' ?
                                        <>
                                            {!docCurrencies?.length ?
                                                <span className="input-group-text left"> {item.Currency ?? newOrderModel.DocCur ?? CURRENCY} </span>
                                                :
                                                <select
                                                    id={`Currency-line${index}`}
                                                    className="input-group-text left"
                                                    style={{ width: 90 }}
                                                    value={item.Currency ?? newOrderModel.DocCur ?? CURRENCY}
                                                    disabled={isPurchaseQuotation}
                                                    onChange={({ target: { value } }) => !isPurchaseQuotation && changeCurrItem(value, index)}>
                                                    {docCurrencies?.map((option, subindex) => <option key={`currOption-${index}-${subindex}`} value={option.CurrCode}>{option.CurrCode}</option>)}
                                                </select>
                                            }
                                        </>
                                        :
                                        <span className="input-group-text left"> {item.Currency ?? newOrderModel.DocCur ?? CURRENCY} </span>
                                    }
                                    <input
                                        type=" text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            width: 130,
                                            textAlign: 'right',
                                        }}
                                        id={'itemCantidad' + index}
                                        disabled={isPurchaseQuotation}
                                        value={item.Price}
                                        onChange={event => !isPurchaseQuotation && !isAnticipo(item.ItemCode) && changePriceItem(event, index)}
                                        onBlur={event => !isPurchaseQuotation && !isAnticipo(item.ItemCode) && validatePriceNull(index)}
                                    />
                                    {
                                        showPriceCalculate &&
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                                            style={{
                                                minWidth: '32px',
                                                alignSelf: 'stretch',
                                                padding: 0
                                            }}
                                            onClick={(event) => {
                                                clickPriceCalculate(index)
                                            }}
                                        >
                                            <i className="fa fa-calculator"></i>

                                        </button>
                                    }

                                </div> :
                                <label>{item.Currency} {formatNumber.new(item.Price)} </label>
                            }
                        </td>}
                        {/* Costo del artículo */}
                        <td style={{ textAlign: 'right' }}>{CURRENCY + " " + formatNumber.new(item.AvgPrice)}</td>
                        {/* Casco */}
                        {(action === 1 && isMarketingDocument(view)) &&
                            <td>
                                <div className="input-group">

                                    <select
                                        disabled={item.U_FMB_IS_CILINDRO === '1'}
                                        value={item?.Casco || 0}
                                        onChange={(e) => item.U_FMB_IS_CILINDRO !== '1' && validateCasco(e, index, item)}
                                        className="form-control">
                                        <option value={0}> No </option>
                                        <option value={1}> Si </option>
                                    </select>
                                </div>
                            </td>
                        }
                        {/*%Descuento*/}
                        <td>
                            <div className='input-group'>
                                <input
                                    maxLength="5"
                                    type="text"
                                    disabled={(action == 2 && !editMode) ? true : (action == 2 && editMode && view == 'draft') ? false : item.LineStatus ? item.LineStatus : !permissions.editDiscountLine}
                                    className=" form-control validar desBlur btn-outline-secondary"
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        widht: 50
                                    }}
                                    id={'iteDescuento' + index}
                                    value={item?.DiscountPercent ?? '0.00'}
                                    onChange={event => changeDiscountItem(event, index)}
                                    onBlur={event => validateDiscountNull(index)}
                                />
                                <div className="input-group-append" >
                                    <i className="fa fa-info-circle"
                                        title={`${_user?.U_Discount || 0}%`}
                                        data-toggle="tooltip"
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: '#EABF28',
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                            marginLeft: 5,
                                            marginTop: 10,
                                        }}
                                        aria-hidden="true" />
                                </div>
                            </div>
                        </td>
                        {/*%Descuento*/}
                        <td style={{ textAlign: 'right' }}>{(item.Currency ?? newOrderModel.DocCur ?? CURRENCY) + " " + formatNumber.new(item?.Discount ?? '0')}</td>
                        {/*Indicador*/}
                        <td style={{ textAlign: 'center' }}>

                            {item?.TaxName?.replace('Percepción', '') || item.TaxCode}
                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus) || (action == 2 && editMode && view == 'draft')) &&
                                !isMarketingDocument(view) &&
                                (
                                    <button
                                        type="button"
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: '#EABF28',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                        }}
                                        className="btn"
                                        onClick={() => openTaxes(index)}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                        </td>

                        {/* Código UM */}
                        {/* Nombre de unidad de medida */}
                        {newOrderModel?.isPurchaseDocument &&
                            <td style={{ textAlign: 'center' }}>
                                {item.UomCode || ''}
                            </td>
                        }
                        {/*Código UMI*/}
                        {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || view === 'PurchaseRequest') && (
                            <td style={{ textAlign: 'center' }}>
                                {item.SalUnitMsr || ''}
                            </td>)
                        }
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && (
                            <td style={{ textAlign: 'center' }}>
                                {item.BuyUnitMsr || ''}
                            </td>)
                        }

                        {/*Impuesto*/}
                        {(view !== 'GoodsReceipt' && view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'purchaseReturn') &&
                            <td style={{ textAlign: 'right' }}>{newOrderModel.DocCur + " " + formatNumber.new(item.TaxeResult)}</td>}
                        {/*Total*/}
                        <td style={{ textAlign: 'right' }}>{newOrderModel.DocCur + " " + formatNumber.new(item.Total)}</td>
                        {false && view !== 'PurchaseRequest' && Modules.CostCenter && <>
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode || ""} />

                                    {(action === 1 || (action === 2 && editMode)) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 1)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            {/* <td>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item.OcrCode2 || ""}/>

                                                            {(action === 1 || (action === 2 && editMode)) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 2)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item.OcrCode3 || ""}/>

                                                            {(action === 1 || (action === 2 && editMode)) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 3)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item.OcrCode4 || ""}/>

                                                            {(action === 1 || (action === 2 && editMode)) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 4)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                disabled
                                                                readOnly
                                                                value={item.OcrCode5 || ""}/>

                                                            {(action === 1 || (action === 2 && editMode)) && (
                                                                <div className="input-group-append" >
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            color: '#EABF28',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                            border: "1px solid #ced4da"
                                                                        }}
                                                                        className="btn btn-outline-secondary"
                                                                        onClick={() => openCentroCoste(index, 5)}>
                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td> */}
                        </>}
                        {(newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument) && Modules.CostCenter && <>
                            {/* CANAL */}
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension1) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 1)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            {/* SEDES */}
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode2 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension2) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 2)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            {/* SUCURSAL */}
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode3 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension3) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 3)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            {/* NEGOCIO */}
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode4 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension4) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 4)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            {/* CECO */}
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode5 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension5) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 5)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                        </>}

                        {/* Orden, Entrada y Factura de proveedor - Pronto Pago */}
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseInvoice') &&
                            <>
                                <td className="text-center" style={{ width: 130 }}>
                                    <label>{FORMAT_NUMBER.new(item.ItemCode === "DESCUENTO" ? 0 : (Number(item.Price || 0) * item.Quantity * Number(newOrderModel.U_FMB_DescPP || 0) / 100))} {newOrderModel.DocCur || item.Currency}</label>
                                </td>
                            </>
                        }
                        {/*Orden de compra - Entrada de mercancia de proveedor*/}
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt') &&
                            <>
                                {/*KilosXComprar*/}
                                <td style={{ width: 130 }}>
                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                        <input
                                            type="text"
                                            className="form-control validarCant cantBlur btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                width: 130,
                                                textAlign: 'right',
                                            }}
                                            id={'KilosXComprar' + index}
                                            value={item.KilosXComprar ?? 0}
                                            onChange={event => changeKilosXComprar(event, index)}
                                            onBlur={() => validateKilosXComprar(index)}
                                        /> :
                                        <label>{item.KilosXComprar ? parseFloat(item.KilosXComprar).toFixed(3) : "0"} KG</label>
                                    }
                                </td>

                                {/*PesosXPieza*/}
                                <td style={{ width: 130 }}>
                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                        <input
                                            type="text"
                                            className="form-control validarCant cantBlur btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                width: 130,
                                                textAlign: 'right',
                                            }}
                                            id={'PesosXPieza' + index}
                                            value={item.PesosXPieza ?? 0}
                                            onChange={event => changePesosXPieza(event, index)}
                                            onBlur={() => validatePesosXPieza(index)}
                                        /> :
                                        <label>{formatNumber.new(item.PesosXPieza ?? '0')}</label>
                                    }
                                </td>

                                {/*PrecioXKilo*/}
                                <td style={{ width: 130 }}>
                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                        <input
                                            type="text"
                                            className="form-control validarCant cantBlur btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                width: 130,
                                                textAlign: 'right',
                                            }}
                                            id={'PrecioXKilo' + index}
                                            value={item.PrecioXKilo ?? 0}
                                            onChange={event => changePrecioXKilo(event, index)}
                                            onBlur={() => validatePrecioXKilo(index)}
                                        /> :
                                        <label>{CURRENCY + formatNumber.new(item.PrecioXKilo ?? '0')}</label>
                                    }
                                </td>
                            </>}

                        {/*Unidad de medida de inventario*/}
                        {/* {((view ==='PurchaseOrder'  || view==='GoodsReceipt' || view ==='purchaseReturn'|| view ==='purchaseInvoice') && (       
                                          <td>
                                                <select className="form-control"
                                                 disabled={(action == 2 && !editMode) ? true : false}
                                                 onChange={event =>this.changeUserFieldsDocumentItemUnitMed(event,index)}
                                                 value={item.UserBaseUn} >
                                                    <option value={'N'}> {'No'}</option>
                                                    <option value={'Y'}> {'Si'}</option>
                                               </select>
                                        </td>))} */}

                        {/* {view !== 'PurchaseRequest' &&
                                            <td>
                                                {item.OcrCode}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => openCentroCoste(index, 1)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                        }
                                        {view !== 'PurchaseRequest' &&
                                            <td>
                                                {item.OcrCode2}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => openCentroCoste(index, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                        }
                                        {view !== 'PurchaseRequest' &&
                                            <td>
                                                {item.OcrCode3}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => openCentroCoste(index, 3)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                        }
                                        {view !== 'PurchaseRequest' &&
                                            <td>
                                                {item.OcrCode4}
                                                {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            color: '#EABF28',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                        }}
                                                        className="btn"
                                                        onClick={() => openCentroCoste(index, 4)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </td>
                                        } */}
                        {/*<td>
                                            {item.OcrCode5}
                                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => openCentroCoste(index, 5)}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button>
                                            )}
                                        </td> */}

                        {/* CAMPOS DE USUARIO LINE */}
                        {json.allItemsUserFields.map((field, indexField) => {
                            if (field.enabled && field.name && ((!newOrderModel?.isPurchaseDocument && field.fieldId !== isTipodeGasto) ||
                                (newOrderModel?.isPurchaseDocument && field.fieldId !== isEntregaCilindro && field.fieldId !== isTipoConvenio && field.fieldId !== isCilindrosVaciosDevueltos))
                            ) {
                                return (
                                    <td style={{ textAlign: 'right' }}>
                                        {(
                                            Number(field.fieldType) === 1 ?
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id={'inputUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    value={field.name == 'Precio x kilo' ? (returnValueItem(field.IdValue, index) || item.PrecioKilo) : returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => changeUserFieldsItemsDocument(event, field.IdValue, index, field.fieldId)}


                                                /> :
                                                <select
                                                    className="form-control"
                                                    id={'selectUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    value={returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => changeUserFieldsItemsDocument(event, field.IdValue, index, field.fieldId)}
                                                >
                                                    {field.options.map((option) => {
                                                        if (option.FldValue != null) {
                                                            return (
                                                                <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }

                                                    })}
                                                </select>
                                        )}
                                    </td>
                                );
                            } else {
                                return (<></>)
                            }
                        })}

                        {newOrderModel?.isPurchaseDocument &&
                            <>
                                {/* Ctd.(UM inventario) */}
                                <td style={{ textAlign: 'center' }}>
                                    <label>{item.InvQty ? formatNumber.new(item.InvQty || 0) : ''} </label>
                                </td>

                                {/* Detalles de artículo */}
                                <td style={{ textAlign: 'center' }}>
                                    <textarea
                                        type="text"
                                        className="form-control styleTextarea"
                                        id="txtText"
                                        placeholder="254 caracteres máximo"
                                        maxLength={254}
                                        disabled={action === 2 && !editMode}
                                        value={item?.Text || ''}
                                        onChange={(event) => changeLineField('Text', index, event.nativeEvent.target.value, 254)}
                                        style={{
                                            backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000',
                                            maxHeight: '40px', overflowY: 'auto', resize: 'none', width: '180px'
                                        }}
                                    />
                                </td>

                                {/* Tipo de Operación */}
                                <td className="text-center">
                                    <select
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={item.U_BPP_OPER || ""}
                                        style={{ maxWidth: 100 }}
                                        onChange={({ target: { value } }) => changeOperation(index, value)}>
                                        {operationList.map((option, subindex) => <option key={`operationList-${index}-${subindex}`} value={option.Code}> {option.Name} </option>)}
                                    </select>
                                </td>

                                {/* Código de Afectación IGV */}
                                <td className="text-center">
                                    <select
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={item.U_STR_FECodAfect || ""}
                                        style={{ maxWidth: 150 }}
                                        onChange={({ target: { value } }) => changeIgvOperation(index, value)}>
                                        <option value={""}> Seleccionar </option>
                                        {!!oneIgvOption?.length && oneIgvOption.map((option, subindex) => <option key={`oneIgvOperationList-${index}-${subindex}`} value={option.Code}> {option.Code} - {option.Name} </option>)}
                                        {item.availableIgvOperationList.map((option, subindex) => <option key={`igvOperationList-${index}-${subindex}`} value={option.Code}> {option.Code} - {option.Name} </option>)}
                                    </select>
                                </td>

                                {/* Sujeto a Impuesto */}
                                <td>
                                    <div className="input-group">
                                        <select
                                            disabled={action === 2 && !editMode ? true : false}
                                            value={item.TaxStatus || 'N'}
                                            onChange={event => changeTaxStatus(event, index)}
                                            className="form-control">
                                            {item.TaxCode === 'EXO' ?
                                                <>
                                                    <option value="N">No</option>
                                                </>
                                                :
                                                <>
                                                    <option value="Y">Sí</option>
                                                    <option value="N">No</option>
                                                </>
                                            }
                                        </select>
                                    </div>
                                </td>

                                {/*Proyecto/Placa*/}
                                <td>
                                    <div className="input-group">
                                        <input
                                            className="form-control"
                                            disabled
                                            readOnly
                                            value={item.Project || ""} />

                                        {(Number(action) === 1 || (Number(action) === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                            <div className="input-group-append" >
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#EABF28',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                        border: "1px solid #ced4da"
                                                    }}
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => openProjects(index)}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </>
                        }

                        {isLocationView && (
                            <>
                                {/* Asignación de ubicación */}
                                <td>
                                    <div className="input-group">
                                        {item.BinActivat === 'Y' &&
                                            <>
                                                <input
                                                    className={`form-control text-right ${action === 1 && Number(item.Quantity) !== Number(item.ToTotalAsigned) ? "text-danger" : ""}`}
                                                    disabled
                                                    readOnly
                                                    value={item.Quantity || ""}
                                                />
                                                {(action === 1 || action === 2) && (
                                                    <div className="input-group-append" >
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                border: "1px solid #ced4da"
                                                            }}
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => action === 2 ? showDocumentStock(item.LineNum) : showLocationAssignment(item.LineNum, 2)}
                                                        >
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        }
                                    </div>
                                </td>
                            </>
                        )}

                        {/* <td style={{textAlign: 'center'}}>
                                            {item.AcctCodeName}
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {item.CogsAcctName}
                                        </td> */}
                        {noPurchaseQuotationExists &&
                            <td
                                className="sticky-columns"
                                style={{
                                    backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                    textAlign: 'center'
                                }}>
                                {/*Eliminar*/}
                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                    <button
                                        disabled={item.U_FMB_IS_CILINDRO === '1'}
                                        type="button"
                                        style={{
                                            backgroundColor: 'transparent',
                                            padding: 5,
                                            color: '#c42222',
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                        }}
                                        className="btn"
                                        onClick={() => deleteItem(index)}>
                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                    </button>
                                )}
                            </td>
                        }

                    </tr>
                );
            })}

            {(noPurchaseQuotationExists && !isCopyToOPOR) &&
                <tr>
                    <td></td>
                    <td className="sticky-column"
                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>


                        {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (

                            <div>
                                <input
                                    type=" text"
                                    placeholder="Artículo"
                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                    // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                    style={{
                                        backgroundColor: 'transparent',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                    }}
                                    onKeyPress={(ev) => {
                                        if (ev.key === 'Enter') {
                                            openItems();
                                        }
                                    }}
                                    value={newOrderModel.searchItem || ''}
                                    onChange={event => changeSearchItem(event)}
                                // onBlur={event => specialPrice(index)}
                                />
                                <button
                                    type="button"
                                    style={{
                                        backgroundColor: 'transparent',
                                        padding: 5,
                                        color: 'green',
                                        paddingTop: 2,
                                        paddingBottom: 2,
                                    }}
                                    className="btn"
                                    onClick={() => openItems()}>
                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        )}
                    </td>
                </tr>
            }
        </>
    }

    emptyField = () => {
        return (
            <td style={{ textAlign: 'center' }}>
                <input
                    type="text"
                    className="form-control btn-outline-secondary"
                    disabled={true}
                    readOnly={true}
                    style={{
                        backgroundColor: 'transparent',
                        borderColor: '#ced4da',
                        color: '#000',
                        paddingTop: 1,
                        paddingBottom: 2,
                        minWidth: 80,
                        textAlign: "center",
                    }}
                    value={''}
                />
            </td>
        )
    }

}

export default OriginalTable;
